<template>
  <v-switch
    :id="id"
    :ref="refName"
    v-bind="$attrs"
    v-model="pValue"
    inset
    @change="onInputChanged($event)"
    color="primary"
  >
    <template #append>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-icon
            class="selector-default-help-icon"
            color="grey"
            size="18"
            v-bind="props"
          >
            mdi-help
          </v-icon>
        </template>
        <span>{{ helpText }}</span>
      </v-tooltip>
    </template>
  </v-switch>
</template>


<script>
import { v4 as uuidv4 } from "uuid";

export default {
  props: {
    id: {
      type: String,
      default: () => uuidv4(),
    },
    value: {
      type: Boolean,
      default: true,
    },
    helpText: {
      type: String,
      default: "",
    },

    tooltipAttrs: {
      type: Object,
      default: () => ({
        bottom: true,
      }),
    },
  },
  data() {
    return {
      pValue: this.value,
    };
  },
  computed: {
    refName() {
      return `${this.id}-help-input`;
    },
  },
  watch: {
    value(newVal) {
      this.pValue = newVal;
    },
  },
  methods: {
    onInputChanged(event) {
      this.$emit("input", event);
    },
    validate() {
      this.$refs[this.refName].validate();
    },
  },
};
</script>


<style lang="scss">
</style>